var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 12,
    viewBox: "0 0 48 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26172 2C1.26172 1.17157 1.93329 0.5 2.76172 0.5H10.7617C11.5901 0.5 12.2617 1.17157 12.2617 2V10C12.2617 10.8284 11.5901 11.5 10.7617 11.5H2.76172C1.93329 11.5 1.26172 10.8284 1.26172 10V2Z",
    fill: "white",
    stroke: "#8B8B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96191 6.35718L5.81347 8.20825L9.72265 4.29907",
    stroke: "#8B8B8B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 2,
    width: 30,
    height: 8,
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox1A);
export default __webpack_public_path__ + "static/media/Checkbox1A.a1d262adbed97012ca9258f66592cb3d.svg";
export { ForwardRef as ReactComponent };